import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime"; function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import {useRef} from 'react'
import useAtmosphere from '../../../hooks/useAtmosphere'
import {useUploadUserAsset} from '../../../mutations/useUploadUserAsset'
import {Button} from '../../../ui/Button/Button'
import jpgWithoutEXIF from '../../../utils/jpgWithoutEXIF'





export const ImageSelectorUploadTab = (props) => {
  const {setImageURL} = props
  const ref = useRef(null)
  const atmosphere = useAtmosphere()
  const [commit] = useUploadUserAsset()
  const onSubmit = async (file) => {
    if (file.type === 'image/jpeg') {
      file = (await jpgWithoutEXIF(file)) 
    }
    if (file.size > 2 ** 23) {
      atmosphere.eventEmitter.emit('addSnackbar', {
        key: 'fileTooBIG',
        message: 'The image is too large. Please select an image smaller than 8MB',
        autoDismiss: 5
      })
    }
    commit({
      variables: {},
      uploadables: {file: file},
      onCompleted: (res) => {
        const {uploadUserAsset} = res
        const {url} = uploadUserAsset
        const message = _optionalChain([uploadUserAsset, 'optionalAccess', _ => _.error, 'optionalAccess', _2 => _2.message])
        if (message) {
          atmosphere.eventEmitter.emit('addSnackbar', {
            key: 'errorUploadIdPtMetadata',
            message,
            autoDismiss: 5
          })
          return
        }
        setImageURL(url)
      }
    })
  }

  const onChange = (e) => {
    const {files} = e.currentTarget
    const imageToUpload = files ? files[0] : null
    if (!imageToUpload) return
    onSubmit(imageToUpload)
  }

  const onClick = () => {
    _optionalChain([ref, 'access', _3 => _3.current, 'optionalAccess', _4 => _4.click, 'call', _5 => _5()])
  }
  return (
    _jsxs('div', { className: "flex min-w-44 items-center justify-center rounded-md bg-slate-100 p-2"      , children: [
      _jsx(Button, { variant: "outline", shape: "pill", className: "w-full", onClick: onClick, autoFocus: true, children: "Upload file"

      })
      , _jsx('input', {
        className: "hidden",
        ref: ref,
        type: "file",
        accept: ".jpg,.jpeg,.png,.webp,.gif",
        onChange: onChange,}
      )
    ]})
  )
}
